import { HEADER_CLICK_IDS } from '../../../types';
import { useTranslation } from 'next-i18next';
import { dispatchGlobalNavigationClick, sendInteractionReward } from '../../../header.utilities';
import { sendReward } from '@dx-ui/framework-conductrics';
import { NavItemWithLink } from '../../nav-items';
import { useHeaderContext } from '../../../context/header-context';
import { useHeaderStateContext } from '../../../context/header-state-context';

export const FindStayNavigationLink = () => {
  const [t] = useTranslation('osc-header');
  const {
    features: { shouldSuppressFindStay, shouldOpenAccountLinksInNewWindow },
    navigation: { onGlobalNavigationClick, isLegacyGlobalNavigationClickAnalyticsEnabled = true },
  } = useHeaderContext();
  const { activeUserLinks: userLinks } = useHeaderStateContext();

  if (!userLinks?.findStayLink || shouldSuppressFindStay) return null;

  return (
    <NavItemWithLink
      namedIcon="calendar-search"
      label={t('yourStays')}
      url={userLinks.findStayLink.url}
      isNewWindow={shouldOpenAccountLinksInNewWindow}
      showNewWindowIcon={false}
      section="user"
      isWide={true}
      onClick={() => {
        sendInteractionReward();
        sendReward('find-stay-click');
        dispatchGlobalNavigationClick(
          HEADER_CLICK_IDS.FindStay,
          onGlobalNavigationClick,
          isLegacyGlobalNavigationClickAnalyticsEnabled
        );
      }}
    />
  );
};
